// extracted by mini-css-extract-plugin
export default {"Paginator":"Paginator_Paginator__9qsDc","paginateButton":"Paginator_paginateButton__WvKUN"};